module.exports = __webpack_public_path__ + "img/world_wide_web.b1128cd2.svg";